// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".page-box[data-v-4834c74a] {\n  width: 100%;\n  height: 100%;\n  box-sizing: border-box;\n}\n.page-box .bg[data-v-4834c74a] {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: calc(var(--vh) * 100);\n  z-index: -1;\n}\n.page-box .item-img[data-v-4834c74a] {\n  width: 6.72rem;\n  height: 2.66667rem;\n}\n", ""]);
// Exports
module.exports = exports;
